import { InteractiveAreaAPI } from './InteractiveAreaAPI'
import { v4 } from 'uuid'

export enum IaActionTypes {
  CREATE = 'Create Interactive Area',
  DELETE = 'Delete Interactive Area',
  DELETE_FROM_SHOT = 'Delete Interactive Area from Shot',
  PASTE = 'Paste Interactive Area',
  DETACH_ENTITY = 'Detach Product/Person from Interactive Area',
  CHANGE = 'Change Interactive Area',
  ATTACH_ENTITY = 'Attach Product/Person to Interactive Area',
  MARK_POINT = 'Mark In or Out point of Interactive Area',
  CHANGE_Z_ORDER = 'Change Z-Order of Interactive Area',
}

export class IaAction {
  readonly id: string
  readonly type: IaActionTypes
  public beforeVersion: InteractiveAreaAPI
  public afterVersion: InteractiveAreaAPI
  private lockAfterVersion: boolean = false

  constructor (type: IaActionTypes, beforeVersion?: InteractiveAreaAPI) {
    this.id = v4()
    this.type = type
    beforeVersion && this.setBeforeVersion(beforeVersion)
  }

  setBeforeVersion = (beforeVersion: InteractiveAreaAPI) => {
    this.beforeVersion = this.removeEventIds(beforeVersion)
    return Promise.resolve()
  }

  setAfterVersion = (afterVersion: InteractiveAreaAPI, lockAfterVersion: boolean = false) => {
    !this.lockAfterVersion && (this.afterVersion = this.removeEventIds(afterVersion))
    this.lockAfterVersion = lockAfterVersion
  }

  private removeEventIds = (interactiveArea: InteractiveAreaAPI) => {
    const events = [...(interactiveArea.events || [])].map(event => ({
      ...event,
      id: null,
      eventId: null,
      interactiveAreaId: null
    }))
    const ia = {
      ...interactiveArea,
      events
    }
    return ia
  }

  get iaId () {
    return (this.beforeVersion || {}).id || (this.afterVersion || {}).id
  }

  updateIaId = (newId: number) => {
    console.log('newId:', newId)
    console.log('action:', this.id)
    if (this.beforeVersion && this.beforeVersion.id) this.beforeVersion.id = newId
    if (this.afterVersion && this.afterVersion.id) this.afterVersion.id = newId
  }
}
